module.exports = __webpack_public_path__ + "static/media/c4d.e0c59ea0.png";